import type { AppState } from '@app/external/common/types';

export const getActiveTab = (state: AppState) => state.activeTab;
